import React, { useState } from "react";
import { X,Send,Search } from "lucide-react";
import InputWithIcons from "./ui/InputWithIcons";
interface ModalProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

function Modal({ open, onClose, children }: ModalProps) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Overlay */}
      <div
        className="absolute inset-0 bg-black/60"
        onClick={onClose}
      />

      {/* Modal content */}
      <div className="relative bg-white rounded-lg shadow-lg w-full max-w-2xl mx-4">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-500 hover:text-red-500"
        >
          <X stroke="#ff0000"className="w-5 h-5" />
        </button>

        {/* Body */}
        <div className="p-6">{children}</div>
      </div>
    </div>
  );
}

interface QuickSendExampleProps {
  handleCloseQuickSend: () => void;
}

export default function QuickSendExample({handleCloseQuickSend}: QuickSendExampleProps) {
  const [open, setOpen] = useState(true);

  return (
    <div className="p-6">
      <Modal open={open} onClose={() => {setOpen(false);handleCloseQuickSend()}}>
        <p className="text-lg flex items-center gap-2 border-b pb-2 border-gray-300">
          <span><Send className="rotate-45" stroke="#4B5563" strokeWidth={1}/></span> <span className="text-gray-600">Quick Send</span>
        </p>

        <div className="mt-6 space-y-4">
          <div>
            <label className="text-sm font-medium">Send to</label>
            <div className="relative mt-1">
                <InputWithIcons
                    leftIcon={<Search className="w-4 h-4" />}
                    placeholder="Search contact"
                />
            </div>
            <div className="w-full flex items-center justify-end text-sm text-gray-800 pt-1 underline">or send a new contact</div>
          </div>

          <div>
            <label className="text-sm font-medium">Category</label>
            <select className="mt-1 w-full rounded-md border border-gray-300 px-3 py-2 text-sm">
              <option>Select</option>
              <option>General</option>
              <option>Reminder</option>
            </select>
          </div>

          <div>
            <label className="text-sm font-medium">Message</label>
            <textarea
              rows={3}
              placeholder="Type your message here..."
              className="mt-1 w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
            />
          </div>
        </div>

        {/* The three send buttons had no onClick and there is no endpoint behind
            any of them — swept 26 Aug 2026: /admin/sendMessage, /admin/sendSms,
            /admin/sendWhatsapp, /admin/sendNotification, /notification/send,
            /message/send, /sms/send, /whatsapp/send, /chat/send, /push/send,
            /mail/send and 18 more all answer "Page not found". They are disabled
            rather than left looking operational: typing a message and clicking
            Whatsapp used to do nothing at all, with no error to explain it. */}
        <div className="mt-6 flex gap-3">
          {["Whatsapp", "SMS", "Chat"].map((channel) => (
            <button
              key={channel}
              type="button"
              disabled
              title="No messaging endpoint is connected yet."
              className="flex-1 cursor-not-allowed rounded-md bg-gray-100 px-4 py-2 text-gray-400"
            >
              {channel}
            </button>
          ))}
        </div>
        <p className="mt-2 text-xs text-gray-500">
          Sending isn't connected yet — there's no messaging endpoint on the API
          for WhatsApp, SMS or chat.
        </p>
      </Modal>
    </div>
  );
}
